import api from '../api/apiClient'
import type { Wallet } from '../models/wallet'

export const walletsRepository = {
  getMyWallet: async (): Promise<Wallet> => {
    const response = await api.get('/wallets/my-wallet')
    return response.data.data
  },
  
  requestWithdraw: async (withdrawalData: {
    amount: string,
  }) => {
    const response = await api.post('/wallets/request-withdraw', withdrawalData)
    return response.data
  }
}